import {
  Directive,
  OnInit,
  Input,
  inject,
  TemplateRef,
  ViewContainerRef,
  OnChanges,
  SimpleChanges,
  ViewRef,
  EmbeddedViewRef,
  HostListener,
  HostBinding,
  Renderer2,
  ElementRef,
  Output,
  EventEmitter,
} from "@angular/core";

@Directive({
  selector: "[hostDragFileContainer]",
})
export class DragFileContainerDirective implements OnInit {
  private dragPlaceholder;
  @Output() onDropped = new EventEmitter<File[]>();

  constructor(private container: ViewContainerRef, private renderer: Renderer2, private el: ElementRef) {}

  ngOnInit() {
    this.createDragPlaceholder();
  }

  private createDragPlaceholder() {
    const div = this.renderer.createElement("div");
    const text = this.renderer.createText("Drop here to attach");
    this.renderer.appendChild(div, text);
    const classList = [
      "absolute",
      "top-0",
      "bottom-0",
      "left-0",
      "right-0",
      "w-full",
      "flex",
      "items-center",
      "justify-center",
      "bg-white/70",
      "text-[20px]",
      "border",
      "border-[#2c80f0]",
      "border-dashed",
      "rounded-[4px]",
      "pointer-events-none",
      "d-none",
    ];
    classList.forEach((c) => {
      this.renderer.addClass(div, c);
    });
    this.renderer.appendChild(this.el.nativeElement, div);
    this.dragPlaceholder = div;
  }

  @HostListener("dragenter", ["$event"])
  onDragEnter(event) {
    event.preventDefault();
    this.renderer.removeClass(this.dragPlaceholder, "d-none");
  }

  @HostListener("dragleave", ["$event"])
  onDragLeave(event) {
    event.preventDefault();
    this.renderer.addClass(this.dragPlaceholder, "d-none");
  }

  @HostListener("drop", ["$event"])
  onDrop(event) {
    event.preventDefault();
    this.renderer.addClass(this.dragPlaceholder, "d-none");
    const { files } = event.dataTransfer;
    if (files.length) {
      // this.handleFiles(files);
      const filesArray: File[] = Array.from(files);
      this.onDropped.emit(filesArray);
    }
  }

  private handleFiles(files) {
    for (const file of files) {
      if (!file.type.startsWith("image/")) {
        return;
      }
      console.log("file: ", file);
    }
  }
}
